module.exports = __webpack_public_path__ + "img/pellets-home-small.77b0e7e.png";